
<template>
	<section>			
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form  :inline="true" :model="filters" style="float: right;" @submit.native.prevent>
			<!-- @keyup.enter.native="List" -->
				<el-form-item>
					<el-input  v-model="filters.Name"  @keyup.enter.native="List" placeholder="门票名称"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button size="width:100%; height:100%;" type="primary" v-on:click="List" icon="el-icon-search">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="handleAdd">添加门票</el-button>
					<el-button size="width:100%; height:100%;" type="warning" :loading="Loading" v-on:click="exportReport" icon="el-icon-search">导出门票</el-button>					
				</el-form-item>			
			</el-form>
		</el-col>

		<!--列表-->
		<el-table  :data="ListData" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width:1702px">
			<el-table-column type="selection" width="55">
			</el-table-column>
			<!-- <el-table-column type="id" width="60" hidden>
			</el-table-column> -->
			<!-- <el-table-column prop="Number" label="教练编号" width="120" sortable>
			</el-table-column> -->
			<el-table-column prop="Name" label="门票名称" width="250" sortable>
			</el-table-column>
			<el-table-column prop="Money" label="门票金额" width="150" sortable>
			</el-table-column>
			<el-table-column prop="TimeLimit" label="门票时限(天)" width="150"  sortable>
			</el-table-column>
			<el-table-column prop="Remark" label="备注" min-width="180" sortable>
			</el-table-column>
            <el-table-column prop="State" label="状态" width="120" sortable fixed="right">				  
				  <template slot-scope="scope" >
                  <div slot="reference" class="name-wrapper">
                  <el-tag type="info" size="medium" v-if="scope.row.State==1">停用</el-tag>
                  <el-tag type="success" size="medium" v-else>启用</el-tag>
                  </div>
                  </template>
			</el-table-column>
			<el-table-column  label="变更状态" width="120" sortable fixed="right">
				<template slot-scope="scope">			
				<el-switch :ref="ListData[scope.$index].Id"   v-model="ListData[scope.$index].BoolState"  active-color="#13ce66" inactive-color="#ff4949" @change="SwitchChange(scope.row)" ></el-switch>
				 </template>
			</el-table-column>
			<el-table-column label="操作" width="200" fixed="right">
				<template  slot-scope="scope">
					<el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
					<el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<!-- <el-tag>当前有{{Count}}位教练</el-tag> -->
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10" :total="total" style="float:right;">
			</el-pagination>
		</el-col>
		<!--编辑界面-->
		<el-dialog title="编辑" v-model="editFormVisible" :close-on-click-modal="false">
			<el-form :model="editForm" label-width="120px" :rules="editFormRules" ref="editForm" @submit.native.prevent>							
				<el-form-item label="门票名称" prop="Name">
					<el-input v-model="editForm.Name" auto-complete="off"></el-input>
				</el-form-item>				
			    <el-form-item label="门票金额" prop="Money">
					<el-input  v-model.number="editForm.Money" auto-complete="off"></el-input>
				</el-form-item>		
			    <el-form-item label="门票时限(天)" prop="TimeLimit">
					<el-input  v-model.number="editForm.TimeLimit" auto-complete="off"></el-input>
				</el-form-item>
                		
				<el-form-item label="备注">
					<el-input type="textarea" v-model="editForm.Remark"></el-input>
				</el-form-item>	
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>

		<!--新增界面-->
		<el-dialog title="新增" v-model="addFormVisible" :close-on-click-modal="false">
			<el-form :model="addForm" label-width="120px" :rules="addFormRules" ref="addForm">
				<el-form-item label="门票名称" prop="Name">
					<el-input v-model="addForm.Name" auto-complete="off"></el-input>
				</el-form-item>				
			    <el-form-item label="门票金额" prop="Money">
					<el-input  v-model.number="addForm.Money" auto-complete="off"></el-input>
				</el-form-item>		
			    <el-form-item label="门票时限(天)" prop="TimeLimit">
					<el-input  v-model.number="addForm.TimeLimit" auto-complete="off"></el-input>
				</el-form-item>
                		
				<el-form-item label="备注">
					<el-input type="textarea" v-model="addForm.Remark"></el-input>
				</el-form-item>			
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="addFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
			</div>
		</el-dialog>
  <!-- 重置界面 -->
	</section>
</template>

<script>
	import util from '../../common/js/util'

	//import NProgress from 'nprogress'
	import { TicketExportReport,TicketList, removeTicket, addTicket,editTicket ,TicketChangeState } from '../../api/api';

	export default {
		data() {
			return {
				filters: {
					Name: ''
				},
		       Loading:false,
				Count:0,
				options:[],
				ListData:[],
				total: 0,
				page: 0,
				listLoading: false,
				sels: [],//列表选中列

				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				editFormRules: {
						Name: [
						{ required: true, message: '请输入姓名', trigger: 'blur' }
                    ],	
                    Money: [
						{ required: true, message: '请输入门票金额'},
                        { type: 'number', message: '必须为数字值'}
                    ],	
                    TimeLimit: [
						{ required: true, message: '请输入门票时限'},
                        { type: 'number', message: '必须为数字值'}
                    ],	            
				},
				//编辑界面数据
				editForm: {
					id: 0,
					Name: '',
					Phone:'',
					Remark:'',
				},
				addFormVisible: false,//新增界面是否显示
				addLoading: false,
				addFormRules: {
					Name: [
						{ required: true, message: '请输入姓名', trigger: 'blur' }
                    ],	
                    Money: [
						{ required: true, message: '请输入门票金额'},
                        { type: 'number', message: '必须为数字值'}
                    ],	
                    TimeLimit: [
						{ required: true, message: '请输入门票时限'},
                        { type: 'number', message: '必须为数字值'}
                    ],	            
                    
				},
				//新增界面数据
				addForm: {
					Name: '',
                    Money:'',
                    Type:'',
                    discount:'',
                    TimeLimit:1,
                    State:'',
					Remark:'',
				}
			}
		},
		methods: {
		exportReport()
			{
				this.Loading=true;
				 let para = {
				};  
  				let downloadName="门票管理";

				 TicketExportReport(para).then((res)=>{	
					 
					 let {status}=res;	
					//  console.log(status);
					 if(status==200)
					 {
	   let blob = new Blob([res.data], {type: "application/vnd.ms-excel"});
	   var downloadElement = document.createElement('a');
var href = window.URL.createObjectURL(blob); //创建下载的链接
downloadElement.href = href;
downloadElement.download = downloadName; //下载后文件名
document.body.appendChild(downloadElement);
downloadElement.click(); //点击下载
document.body.removeChild(downloadElement); //下载完成移除元素
window.URL.revokeObjectURL(href); //释放掉blob对象
						 this.Loading=false;
					 }
					 else
					 {
						 this.Loading=false;
					 }

		   })
			},			
           SwitchChange(row){
                // console.log(1);
			   row.State=row.BoolState==true?0:1;			 
                let para={
                    id:row.Id
                }
              TicketChangeState(para).then((res)=>{
              }).catch(error=>{
                 alert('网络错误');
                });
            },
			formatDate: function (row, column) {
				return util.formatDate.format(new Date(row.Birthday), 'yyyy-MM-dd');
			},
			// formatState: function (row, column) {
			// 	return row.State == 1 ? '暂停' : row.State == 0 ? '启用' : '未知';
			// },
			//性别显示转换
			handleCurrentChange(val) {
				this.page = val;
				this.List();
			},
			//获取用户列表
		
			List() {
				// this.getCount();
				let para = {
					PageIndex: this.page-1,					
					PageSize:10,
					Name:this.filters.Name
				};
				this.listLoading = true;
				//NProgress.start();
				TicketList(para).then((res) => {
					//在浏览器打印出来可以看到 返回的信息应该怎么点
					//结合vsapi写法
					// this.total = res.data.total;
					// this.users = res.data.data;
					//前端mock测试
					this.total = res.data.TotleCount;
					this.ListData =res.data.Data;
                    this.Count=res.data.TotleCount;
					this.listLoading = false;
					//NProgress.done();
				})
				 .catch(error=>{
                 alert('网络错误');
                });
			},							
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { id: row.Id 					   
					};
					removeTicket(para).then((res) => {
						this.listLoading = false;
						//NProgress.done();
						let { Success,Msg } = res.data;
						if(Success)
						{
						this.$message({
							message: '删除成功',
							type: 'success'
						});
						this.List();
						}
						else{
						this.$message({
							message: Msg,
							type: 'error'
						});
						}
					});
				}).catch(() => {
				});
			},
			//显示编辑界面
			handleEdit: function (index, row) {
				this.editFormVisible = true;
				this.editForm = Object.assign({}, row);

			},
			//显示新增界面
			handleAdd: function () {
				this.addFormVisible = true;
				this.addForm = {
					Name: '',
                    Money:'',
                    Type:'',
                    discount:'',
                    TimeLimit:1,
                    State:'',
					Remark:'',					
				};
			},
			//编辑
			editSubmit: function () {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.editLoading = true;
							//NProgress.start();							
							let para = Object.assign({}, this.editForm);
							para.Birthday = (!para.Birthday || para.Birthday == '') ? '' : util.formatDate.format(new Date(para.Birthday), 'yyyy-MM-dd');
							editTicket(para).then((res) => {
								this.editLoading = false;
								//NProgress.done();
								// console.log(res);
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
								});
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								});
								}
								
								this.$refs['editForm'].resetFields();
								this.editFormVisible = false;
								this.List();
							});
						});
					}
				});
			},
			//新增
			addSubmit: function () {
				this.$refs.addForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.addLoading = true;
							//NProgress.start();
							let para= Object.assign({}, this.addForm);							
							// console.log(para);
							para.Birthday = (!para.Birthday || para.Birthday == '') ? '' : util.formatDate.format(new Date(para.Birthday), 'yyyy-MM-dd');
							addTicket(para).then((res) => {							
								this.addLoading = false;
								//NProgress.done();
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
								});
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								});
								}
								this.$refs['addForm'].resetFields();
								this.addFormVisible = false;
								this.List();
							}) .catch(error=>{
                            alert('系统错误');
                            });														
						});
					}
				});
			},
			selsChange: function (sels) {
				this.sels = sels;
			},

   closeDialog(){
		this.inputIdCard="";
      this.onCellClick(event);
    },
   onCellClick(event)
   {
      this.$nextTick(function(){
         this.$refs['siteInput'].focus();
          // this.$(event.target).children().find("input").focus();
      })
   },
		},
		mounted() {
			this.List();
			// this.getCount();
		}
	}

</script>

<style scoped>
 /* .el-form-item {
    margin-bottom: 22px;
    height: 18px;
    } */
	.el-input__inner {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bfcbd9;
    box-sizing: border-box;
    color: #1f2d3d;
    font-size: inherit;
    height: 36px;
	width: 300px;
    line-height: 1;
    outline: 0;
    padding: 3px 10px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}
.input {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bfcbd9;
    box-sizing: border-box;
    color: #1f2d3d;
    font-size: inherit;
    height: 36px;
    line-height: 1;
    outline: 0;
    padding: 3px 10px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}

</style>


// WEBPACK FOOTER //
// Ticket.vue?bc85266a